import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = {
  isLoading: false,
  apiError: null,
  isValid: true,
};

const onRequest = state => ({
  ...state,
  apiError: null,
  isLoading: true,
  isValid: true,
});

const onSuccess = (state, { payload: isValid }) => ({
  ...state,
  isValid,
  apiError: null,
  isLoading: false,
});

const onFailure = (state, { payload: message }) => ({
  ...state,
  isValid: false,
  isLoading: false,
  apiError: message,
});

const isValidCode = state => ({
  ...state,
  isValid: true,
});

const clearState = () => initialState;

export default createReducer(initialState, {
  [actionTypes.FETCH_VALIDATE_CODE_REQUEST]: onRequest,
  [actionTypes.FETCH_VALIDATE_CODE_SUCCESS]: onSuccess,
  [actionTypes.FETCH_VALIDATE_CODE_FAILURE]: onFailure,
  [actionTypes.FETCH_GENERATE_CODE_SUCCESS]: isValidCode,
  [actionTypes.OPEN_CODE_MODAL]: clearState,
});
